import { Default } from 'fullcalendar/Interaction';

function Map(input: object, mapHook: boolean = true): object {
    if (!input) return null;

    let output: object = (input instanceof Array) ? [] : {};
    let dateRegExp: RegExp = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z|)/;

    for (let key in input) {
        let type = typeof (input[key]);

        if (type === "undefined") {
            continue;
        }
        else if (mapHook && type === "string" && dateRegExp.test(input[key])) {
            output[key] = new Date(input[key]);
        }
        else if (type === "object") {
            output[key] = Map(input[key], mapHook);
        }
        else {
            output[key] = input[key];
        }
    }

    return output;
}

export const DefaultMapping = (input: object): object => Map(input, true);

export const DefaultCopy = (input: object): object => Map(input, false);


export function CopyFromElement(id: any) {
    var input = (document.getElementById(id) as any)
    input.select();
    try {
        document.execCommand('copy');
    } catch (err) {
        console.log('Can`t copy, boss');
    }
    window.getSelection().removeAllRanges();
}

export function RemoveDuplicates(array: any[]): any[] {
    return array.filter(function (item, pos) {
        return array.indexOf(item) == pos;
    })
}

export function Sort(a: any, b: any, isAscSort: boolean, children?: string): number {
    var aItem, bItem;
    if (!!children && children != "") {
        aItem = a[children];
        bItem = b[children];
    } else {
        aItem = a;
        bItem = b;
    }
    var sign = isAscSort ? 1 : -1;
    let dateRegExp: RegExp = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z|)/;
    let type = typeof (a[children]);

    if (type === "string" && dateRegExp.test(a[children])) {
        if (aItem.getTime() > bItem.getTime()) return 1 * sign;
        if (aItem.getTime() < bItem.getTime()) return -1 * sign;
    } else {
        if (aItem > bItem) return 1 * sign;
        if (aItem < bItem) return -1 * sign;
    }
    return 0;
}